/**
 * `Tools: ToolsApi` (W2-11 batch-tools; contract src/core/tools/types.ts, DESIGN.md §5.8): the generators and batch
 * tools, every one a pure function over a TxBuilder, so the UI runs it inside a live gesture (ghost preview) and
 * commits one undoable transaction. `applyTemplate` is owned by W2-05 (templates.ts) and re-exported here.
 */

import { cloneToLines } from './clone';
import { distribute, distributeExpression } from './distribute';
import { fillBetween } from './fill';
import { fit } from './fit';
import { flattenLayers } from './flatten';
import { motionPath } from './motionPath';
import { stagger } from './stagger';
import { applyTemplate } from './templates';
import type { ToolsApi } from './types';

export { applyTemplate } from './templates';

export const Tools: ToolsApi = {
  distribute,
  distributeExpression,
  cloneToLines,
  fillBetween,
  motionPath,
  applyTemplate,
  flattenLayers,
  fit,
  stagger,
};
